import { render, staticRenderFns } from "./BrowserAgentLayout.vue?vue&type=template&id=1bcc77d0&scoped=true"
import script from "./BrowserAgentLayout.vue?vue&type=script&lang=js"
export * from "./BrowserAgentLayout.vue?vue&type=script&lang=js"
import style0 from "./BrowserAgentLayout.vue?vue&type=style&index=0&id=1bcc77d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc77d0",
  null
  
)

export default component.exports